// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { Box, IconButton } from '../../../lib/base';
import { CloseIcon } from '../../../lib/icons';

interface Props {
  readonly onCloseDialog: () => void;
  readonly dontShiftUp?: boolean;
}

export default function ExitDialogButton({ onCloseDialog, dontShiftUp }: Props) {
  const icon = (
    <IconButton aria-label="exit-dialog" sx={{ p: 1 }} size="small" onClick={onCloseDialog}>
      <CloseIcon fontSize="small" />
    </IconButton>
  );
  if (dontShiftUp) {
    return icon;
  }
  return <Box sx={{ mb: '-20px', display: 'flex', justifyContent: 'flex-end', width: '100%' }}>{icon}</Box>;
}
